import { render } from "./ThePopular.vue?vue&type=template&id=6cc03244&scoped=true"
import script from "./ThePopular.vue?vue&type=script&lang=js"
export * from "./ThePopular.vue?vue&type=script&lang=js"

import "./ThePopular.vue?vue&type=style&index=0&id=6cc03244&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc03244"]])

export default __exports__